import { Injectable } from '@angular/core';
import { GenericService } from './generic.service';
import { StorageService } from './storage.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class LlmIntegrationService {

  urlConstants:any = {
    OPEN_API: 'api/openai/chat/completions',
    TEXT_FORMALIZATION: 'api/openai/activities/text-formalization',
    TEXT_FORMALIZATION_SEARCH: 'api/openai/activities/text-formalization/search',
  }
  
  constructor(
    private genericService: GenericService,
    private StorageService: StorageService,
    private authService: AuthService
  ) { }

  sendRequest(
    prompt: string,
    model: string = 'gpt-5-nano',
    options?: { temperature?: number; max_tokens?: number; stop?: string[]; n?: number },
    successCallback: (data: any) => void = () => {},
    errorCallback: (err: any) => void = () => {}
  ) {

    const body: any = {
      model: model,
      messages: [
        { role: 'user', content: prompt }
      ]
    };

    if (options) {
      if (options.temperature !== undefined) body.temperature = options.temperature;
      if (options.max_tokens !== undefined) body.max_tokens = options.max_tokens;
      if (options.stop !== undefined) body.stop = options.stop;
      if (options.n !== undefined) body.n = options.n;
    }

    this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.OPEN_API, body).subscribe((data) => {
      successCallback(data.body)
    }, (error) => {
      errorCallback(error.error);
    });
}


  saveTextFormalization(payload, successCallback, errorCallback) {
    this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.TEXT_FORMALIZATION + '/' + this.authService.getUserDetails().company.companyId + '/' + this.authService.getUserDetails().id, [payload]).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  saveBulkTextFormalization(payloads: any[], successCallback, errorCallback) {
    this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.TEXT_FORMALIZATION + '/' + this.authService.getUserDetails().company.companyId + '/' + this.authService.getUserDetails().id, payloads).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  getTextFormalization(successCallback, errorCallback) {
    this.genericService.getObjects(this.StorageService.get('baseurl') + this.urlConstants.TEXT_FORMALIZATION + '/' + this.authService.getUserDetails().company.companyId + '/' + this.authService.getUserDetails().id).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

  getTextFormalizationFiltered(filter: any, successCallback, errorCallback) {
    const payload: any = {
      companyId: filter.companyId || this.authService.getUserDetails().company.companyId,
      clientOrBUId: filter.clientOrBUId || null,
      activityType: 'TEXT_FORMALIZATION',
      startDate: filter.startDate || null,
      endDate: filter.endDate || null,
      createdBy: filter.createdBy || null,
      requisitionId: filter.requisitionId || null,
      requisitionNumber: filter.requisitionNumber || null,
      page: filter.page !== undefined ? filter.page : 0,
      size: filter.size || 2000
    };
    this.genericService.addObject(this.StorageService.get('baseurl') + this.urlConstants.TEXT_FORMALIZATION_SEARCH + '/' + this.authService.getUserDetails().company.companyId + '/' + this.authService.getUserDetails().id, payload).subscribe((data) => {
      successCallback(data.body);
    }, (error) => {
      errorCallback(error.error);
    });
  }

}
